export function withHost(path: string) {
  const { resourcesUrl } = useRuntimeConfig().public
  return resourcesUrl + path
}
